import type { ActivePushTopic, PushTopic } from '@/push/types';
import asDict from '@whiz-cart/node-shared/models/helpers/asDict';
import _ from 'lodash';

export const expandTopics = asDict({
    sessionMonitor: asDict({
        service: ['sessionMonitor_service'],
        detective: ['sessionMonitor_detective'],
        storeManager: ['sessionMonitor_service', 'sessionMonitor_detective'],
        rollout: ['sessionMonitor_service', 'sessionMonitor_detective'],
        admin: ['sessionMonitor_admin', 'sessionMonitor_service', 'sessionMonitor_detective'],
    }),
});

export const withoutTopic = (active: ActivePushTopic[], { topic, storeGuid }: ActivePushTopic) =>
    active.filter((x) => !(x.topic === topic && x.storeGuid === storeGuid));

export const calcTopics = (pushTopics: PushTopic[], roles: string[], storeGuid: string | null): ActivePushTopic[] => {
    return _.uniqBy(
        pushTopics
            .filter((pushTopic) => pushTopic.type !== 'store' || storeGuid)
            .map((pushTopic) => {
                if (pushTopic.type === 'store') {
                    return { topic: pushTopic.topic, storeGuid };
                }

                return { topic: pushTopic.topic, storeGuid: pushTopic.storeGuid };
            })
            .flatMap((pushTopic) => {
                const expand = expandTopics[pushTopic.topic];
                if (!expand) return [pushTopic];
                return roles.flatMap((role) => (expand[role] ?? []).map((topic) => ({ ...pushTopic, topic })));
            }),
        (x) => JSON.stringify([x.topic, x.storeGuid]),
    );
};
